import { useMemo } from 'react';
import { useOrdersState } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/context/orders-context';
import { Recommendation } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/types/recommendation-assortment.type';

/** Recommendations filtered by the forecast / skipped filter buttons. */
export const useFilteredRecommendations = (filters: string[]) => {
  const {
    recommendationAssortmentQuery: { data: recommendationAssortment, isLoading },
  } = useOrdersState();

  const recommendations = useMemo(() => recommendationAssortment?.recommendations || [], [recommendationAssortment]);

  const filteredRecommendations: Recommendation[] = useMemo(() => {
    const arr: Recommendation[] = [];

    if (!filters.length) return recommendations;

    recommendations.forEach((recommendation) => {
      const isSkipped = recommendation.autoSkipped || recommendation.manuallySkipped;
      if (filters.includes('skipped')) isSkipped && arr.push(recommendation);
      if (filters.includes('forecast')) !isSkipped && arr.push(recommendation);
    });

    return arr;
  }, [recommendations, filters]);

  return { filteredRecommendations, isLoading };
};
